import {LoadingButton} from '@mui/lab';
import {Box} from '@mui/material';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {saveFile} from '../../utils/file';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

const AssetMachineExport = () => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);
  const fetchData = async () => {
    setIsFetching(true);
    try {
      const resp = await API.get(`${apiBaseUrl}/asset-machine.csv`, {
        responseType: 'blob',
      });
      saveFile(resp.data, `asset-machines-${dayjs().format('YYYY-MM-DD')}.csv`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_349ece77");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          loading={isFetching}
          onClick={() => fetchData()}
        >
          Export as CSV
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default AssetMachineExport;
